import Input from './input';
import TextArea from './textarea';

Input.TextArea = TextArea;

export default Input;
